/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class GameParser {

    static parseLaunch(launcherConfig) {
        let gameDirectory = GameParser.getGameDirectory({ type: launcherConfig.gameType, provider: launcherConfig.gameProvider });

        return {
            namespace: `com.${launcherConfig.gameProvider}.game`,
            preconfig: {
                cdn: `${launcherConfig.cdn}${gameDirectory}/${launcherConfig.gameId}/`,
                defaultLang: launcherConfig.defaultLanguage,
                disclaimer: launcherConfig.disclaimer,
                gameType: launcherConfig.gameType,
                timestamp: `${launcherConfig.cacheBust}1`
            }
        };
    }

    static parse(cfg, settings, options) {
        let timestamp = cfg.bridge.timestamp;

        cfg.game.preconfig.hasRtp = cfg.bars.options.hasRtp;
        cfg.game.preconfig.increaseSpeedByPercent = 0;
        cfg.game.preconfig.skipJackpotWin = true;
        cfg.game.preconfig.timestamp = `${timestamp.substr(3)}1`;
        if (cfg.bars.options.hasPreloader) {
            cfg.game.preconfig.splash = false;
	        delete cfg.game.preconfig.disclaimer;
        }

        if ((options.isSlot && options.isRTG) && !cfg.game.preconfig.mappedSkin) {
            delete cfg.game.preconfig.skin;
        }

        if (!cfg.game.preconfig.localizationsPath) {
            cfg.game.preconfig.localizationsPath = `${cfg.game.preconfig.cdn}../../localizations/`;
        }

        return cfg.game;
    }

    static getGameDirectory({ type, provider }) {
        let directory = type==='slot' ? 'slots' : 'table';
        if (provider !== 'casino') {
            directory = `slots-${provider}`;
        }

        return directory;
    }

}


module.exports = GameParser;
